// src/main.js
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { initializeStores } from './store'
import { resetPlugin, persistStatePlugin } from './store/plugins'
import ApiService from './services/apiService'

// Import Tailwind CSS
import './assets/css/main.css'

// Import global components
import Toast from './components/ui/Toast.vue'
import {
  BaseButton,
  BaseCard,
  BaseInput,
  BaseSelect,
  BaseModal,
  BaseBadge,
  BaseIcon
} from './components/base'

// Créez l'instance Pinia avec plugins
const pinia = createPinia()
pinia.use(resetPlugin)
pinia.use(persistStatePlugin)

ApiService.init('https://jaaba-cloud.digita.sn/api')
// ApiService.init('http://192.168.1.28:8000/api')  
// ApiService.init('http://127.0.0.1:8000/api')  

// Créez l'application et ajoutez les plugins
const app = createApp(App)

app.use(router)
app.use(pinia)

// Register global components
app.component('BaseToast', Toast)
app.component('BaseButton', BaseButton)
app.component('BaseCard', BaseCard)
app.component('BaseInput', BaseInput)
app.component('BaseSelect', BaseSelect)
app.component('BaseModal', BaseModal)
app.component('BaseBadge', BaseBadge)
app.component('BaseIcon', BaseIcon)

// Initialiser les stores
initializeStores()

// Montez l'application
app.mount('#app')